import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = ({ user, open, setOpen }) => {
  const location = useLocation();
  const navi = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const isActive = (path) => location.pathname === path;

  // --- MENU DATA ---
  const menuAdmin = [
    { name: "Dashboard", path: "/dashboard" },
    { name: "Tagihan", path: "/tagihan" },
    { name: "Pembukuan", path: "/pembukuan" },
    { name: "User", path: "/user" },
    { name: "Pengajuan", path: "/pengajuan" },
  ];

  const menuUser = [
    { name: "Dashboard", path: "/dashboard" },
    { name: "Tagihan", path: "/tagihan" },
    { name: "Pengajuan", path: "/pengajuan" },
    { name: "Profile", path: "/profile" },
  ];

  const menus = user?.role === "admin" ? menuAdmin : menuUser;

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      {/* 1. TOMBOL HAMBURGER (MUNCUL SAAT SIDEBAR TERTUTUP) */}
      {/* Tombol ini berada DI LUAR sidebar agar tidak ikut hilang saat sidebar ditutup */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-md text-gray-600 hover:bg-gray-100 hover:text-navBase transition-all"
          aria-label="Buka Menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      )}

      {/* 3. SIDEBAR CONTAINER */}
      <aside
        className={`
          fixed top-0 left-0 z-50 h-screen w-64 bg-white shadow-2xl 
          transition-transform duration-300 ease-in-out
          flex flex-col justify-between
          ${open ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        {/* --- BAGIAN ATAS --- */}
        <div className="flex flex-col h-full">
          {/* Header Sidebar */}
          <div className="flex items-center justify-between px-6 py-6">
            <h1
              className="text-3xl font-bold cursor-pointer text-navBase"
              onClick={() => navi("/")}
            >
              ecotrace.
            </h1>

            {/* TOMBOL CLOSE (X) - MUNCUL SAAT SIDEBAR TERBUKA */}
            <button
              onClick={() => setOpen(false)}
              className="p-2 rounded-md text-gray-500 hover:bg-gray-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Menu Items */}
          <nav className="flex-1 px-4 mt-4 space-y-2 overflow-y-auto">
            {menus.map((m) => (
              <div
                key={m.path}
                onClick={() => {
                  navi(m.path);
                  // Auto close di HP setelah klik menu
                  if (window.innerWidth < 1024) setOpen(false);
                }}
                className={`
                  flex items-center px-4 py-3 text-sm font-medium rounded-xl cursor-pointer transition-colors
                  ${
                    isActive(m.path)
                      ? "bg-navBase text-white shadow-md"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                  }
                `}
              >
                {m.name}
              </div>
            ))}
          </nav>

          {/* --- BAGIAN BAWAH: PROFIL --- */}
          <div className="p-4 border-t border-gray-100 bg-white">
            <div className="relative">
              {/* Pop-up Menu */}
              {showMenu && (
                <div className="absolute bottom-full left-0 w-full mb-2 bg-white border border-gray-100 rounded-xl shadow-lg animate-in slide-in-from-bottom-2 fade-in duration-200">
                  <div className="p-4 border-b border-gray-100">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {user?.nama}
                    </p>
                    <p className="text-xs text-gray-500 capitalize">
                      {user?.role}
                    </p>
                  </div>
                  <div className="p-1">
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full gap-2 px-4 py-2 text-sm text-red-600 rounded-lg hover:bg-red-50 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
                        />
                      </svg>
                      Logout
                    </button>
                  </div>
                </div>
              )}

              {/* Trigger Profil */}
              <div
                onClick={() => setShowMenu(!showMenu)}
                className="flex items-center gap-3 p-2 transition-colors rounded-xl cursor-pointer hover:bg-gray-50"
              >
                <div className="flex items-center justify-center w-10 h-10 text-gray-600 bg-gray-100 rounded-full shrink-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="flex-1 min-w-0 hidden md:block">
                  {" "}
                  {/* Nama user disembunyikan jika layar sangat kecil agar rapi */}
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {user?.nama || "User"}
                  </p>
                  <p className="text-xs text-gray-500 truncate capitalize">
                    {user?.role === "admin" ? "Administrator" : "User"}
                  </p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${
                    showMenu ? "rotate-180" : ""
                  }`}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m4.5 15.75 7.5-7.5 7.5 7.5"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
